module.exports = __webpack_public_path__ + "img/DW365-227.6ee8a7fb.jpg";